import React from 'react';
import { UserIcon } from 'lucide-react';
export function Leadership() {
  return <section className="py-24" style={{
    backgroundColor: '#F8F9FA'
  }} aria-labelledby="leadership-title" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-157">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-158">
          <p className="section-label" data-id="element-159">Our Team</p>
          <h2 id="leadership-title" className="section-title" data-id="element-160">
            Leadership Team
          </h2>
          <p className="text-[#6B6B6B] max-w-xl mx-auto text-base leading-relaxed" data-id="element-161">
            Experienced professionals dedicated to delivering exceptional
            consulting services.
          </p>
        </div>

        {/* Cards */}
        <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-162">
          {/* Oscar Rodriguez */}
          <div className="bg-white rounded-2xl p-8 shadow-md text-center border border-gray-100" data-id="element-163">
            <div className="w-24 h-24 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-5 border-4 border-white shadow-md" data-id="element-164">
              <UserIcon size={36} color="#6B6B6B" aria-hidden="true" data-id="element-165" />
            </div>
            <h3 className="text-xl font-bold text-[#3C3C3C] mb-1" data-id="element-166">
              Oscar Rodriguez
            </h3>
            <p className="text-sm text-[#6B6B6B] leading-snug mb-4" data-id="element-167">
              Founder &amp; Business and Technology Consultant
            </p>
            <div className="inline-block px-3 py-1 rounded-full text-xs font-semibold" style={{
            backgroundColor: '#3A9A6A1A',
            color: '#3A9A6A'
          }} data-id="element-168">
              Founder
            </div>
          </div>

          {/* Emma Rodriguez */}
          <div className="bg-white rounded-2xl p-8 shadow-md text-center border border-gray-100" data-id="element-169">
            <div className="w-24 h-24 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-5 border-4 border-white shadow-md" data-id="element-170">
              <UserIcon size={36} color="#6B6B6B" aria-hidden="true" data-id="element-171" />
            </div>
            <h3 className="text-xl font-bold text-[#3C3C3C] mb-1" data-id="element-172">
              Emma Rodriguez
            </h3>
            <p className="text-sm text-[#6B6B6B] leading-snug mb-4" data-id="element-173">
              Director of Operations
            </p>
            <div className="inline-block px-3 py-1 rounded-full text-xs font-semibold" style={{
            backgroundColor: '#3A9A6A1A',
            color: '#3A9A6A'
          }} data-id="element-174">
              Leadership
            </div>
          </div>
        </div>
      </div>
    </section>;
}